import { getFamilyAlbumsFeature, getFamilyFoldersFeature } from 'reactApp/modules/family/family.selectors';
import { handleMakeFamilyFolderCommon } from 'reactApp/modules/modifying/sagas/createFolder.saga';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

import { getCurrentFolder } from './helpers/getCurrentFolder';
import { getSelectedItems } from './helpers/getSelectedItems';

export const makeFamilyFolderCommon = () => {
    const state = reduxStore.getState();
    const selectedItems = getSelectedItems(state);
    const currentFolder = getCurrentFolder(state);
    const { isFamilyFolders } = getStorage(getCurrentStorage(state));

    const hasFamilyFoldersFeature = getFamilyFoldersFeature(state);
    const hasFamilyAlbumsFeature = getFamilyAlbumsFeature(state);
    const isFamilyTariff = hasFamilyFoldersFeature && hasFamilyAlbumsFeature;

    sendDwh({
        eventCategory: 'dropdown-undo-family-folder-click',
        dwhData: {
            is_family_member: isFamilyTariff ? 1 : 0,
        },
    });

    handleMakeFamilyFolderCommon(selectedItems[0] || currentFolder, isFamilyFolders);
};
